export default {
	root: {
		borderRadius: 12,
		textTransform: "inherit"
	}
}
